import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".DeliveryInterval-module_wrapper__TTaTi {\n  margin: 20px 0;\n}\n.DeliveryInterval-module_wrapper__TTaTi .DeliveryInterval-module_info__G2EDP {\n  margin: 4px 0 0;\n  color: var(--pp-color-text-subtle, #706E6A);\n}";
var styles = {"wrapper":"DeliveryInterval-module_wrapper__TTaTi","info":"DeliveryInterval-module_info__G2EDP"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
//# sourceMappingURL=DeliveryInterval.module.scss.js.map
